<template>
  <div class="modal fade leave-details-modal" data-bs-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-labelledby="leaveDetailsLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title" id="leaveDetailsLabel">Leave Application Details</h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <table class="table table-bordered">
            <tbody>
            <tr>
              <th width="40%">Employee Name</th>
              <td>{{ leave.names || '-' }}</td>
            </tr>
            <tr>
              <th>Leave Type</th>
              <td>{{ leave.leaveTypeName || '-' }}</td>
            </tr>
            <tr>
              <th>Application Date</th>
              <td>{{ formatDate(leave.createdAt) }}</td>
            </tr>
            <tr>
              <th>From Date</th>
              <td>{{ formatDate(leave.startDate) }}</td>
            </tr>
            <tr>
              <th>To Date</th>
              <td>{{ formatDate(leave.endDate) }}</td>
            </tr>
            <tr>
              <th>No. of Days</th>
              <td>{{ leave.totalDays || 0 }} Days</td>
            </tr>
            <tr>
              <th>Leave Reason</th>
              <td>{{ leave.reason || '-' }}</td>
            </tr>
            <tr>
              <th>Status</th>
              <td>
                  <span
                      class="badge rounded-pill"
                      :class="{
                      'bg-success': leave.status === 'Approved',
                      'bg-danger': leave.status === 'Rejected',
                      'bg-warning': leave.status === 'Pending'
                    }"
                  >
                    {{ leave.status || 'Unknown' }}
                  </span>
              </td>
            </tr>
            <tr v-if="leave.approvalDate">
              <th>Approval Date</th>
              <td>{{ formatDate(leave.approvalDate) }}</td>
            </tr>
            <tr v-if="leave.approvedBy">
              <th>Approved By</th>
              <td>{{ leave.approvedBy || '-' }}</td>
            </tr>
            <tr v-if="leave.rejectionReason">
              <th>Rejection Reason</th>
              <td>{{ leave.rejectionReason }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeaveDetailsModal',
  props: {
    leave: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '-';
      const d = new Date(date);
      const options = { day: 'numeric', month: 'short', year: 'numeric' };
      return d.toLocaleDateString('en-US', options);
    }
  },
  mounted() {
    // Remove any backdrop that Bootstrap might add
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove();
    }
  }
}
</script>

<style scoped>
/* Make backdrop lighter - not too dark */
:deep(.modal-backdrop) {
  background-color: rgba(0, 0, 0, 0.2) !important; /* 20% opacity instead of default 50% */
}

:deep(.modal-backdrop.show) {
  opacity: 1 !important;
}

.modal-content {
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  border: 1px solid rgba(0,0,0,0.1);
}

.btn-close-white {
  filter: invert(1) grayscale(100%) brightness(200%);
}
</style>